<template>
  <div
    class="customer layout pc"
    :class="mainColor"
    :style="{ height: height + 'px' }"
  >
    <evaluate-page />
    <router-view></router-view>
    <loading v-if="isload" />
    <!-- 通知 -->
    <el-dialog
      title="维护通知"
      :visible="SysNotice"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="false"
      :show-close="false"
      top="20vh"
      width="50%"
      center
    >
      <span style="white-space: pre-line;line-height:1.5">{{
        domain && domain.NOTICE_URL
      }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="close">好的，我知道了</el-button>
      </span>
    </el-dialog>

    <!--  开启了多个窗口-->
    <el-dialog
      title="请在最新的标签查看"
      :visible="isShowWinTagClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="false"
      :show-close="false"
      top="20vh"
      width="50%"
      center
    >
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="close">好的，我知道了</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import reconnect from "src/mixins/reconnect";
import unloadEvent from "src/mixins/unloadEvent";
import refreshAndClose from "src/mixins/refreshAndClose";
import loading from "../../../components/loading/loading";
import utils from "../utils";
// import service from "src/app/customer/service";
export default {
  name: "app",
  data() {
    return {
      color: "red"
    };
  },
  components: {
    loading
  },
  mixins: [reconnect, unloadEvent, refreshAndClose],
  // created() {
  // service.queryServerConfig().then(res => {
  //   if (res) {
  //     if (res.code == 200 && res.data) {
  //       sessionStorage.setItem("serverTime", res.data.dateTime);
  //     }
  //   }
  // });
  // },
  mounted() {
    this.editHeight();
    let that = this;
    console.log(this.domain && this.domain.NOTICE_URL, "dayin");
    // 覆盖鼠标滑动
    document.body.addEventListener(
      "wheel",
      e => {
        if (e.ctrlKey) {
          if (e.deltaY < 0) {
            e.preventDefault();
            return false;
          }
          if (e.deltaY > 0) {
            e.preventDefault();
            return false;
          }
        }
      },
      { passive: false }
    );
    window.onresize = function temp() {
      that.editHeight();
    };
  },
  computed: {
    ...mapState(["isload", "mainColor", "height", "SysNotice", "domain"]),
    ...mapState({
      isShowWinTagClose: state => state.modal.isShowWinTagClose
    })
  },
  methods: {
    close() {
      utils.closePage();
      this.$store.commit("setState", {
        SysNotice: false
      });
    },
    change() {
      this.$store.dispatch("setTheme", this.color);
    },
    editHeight() {
      if (document.documentElement.clientHeight > 800) {
        this.$store.commit("setState", { height: 800 });
      } else {
        this.$store.commit("setState", {
          height: document.documentElement.clientHeight
        });
      }
    }
  }
};
</script>

<style scoped lang="less">
.customer {
  width: 700px;
  position: absolute;
  left: 50%;
  top: calc(50% - 10px);
  transform: translateX(-50%) translateY(-50%);
  display: flex;
  flex-direction: column;
  box-shadow: 0 0 2px rgba(51, 60, 89, 0.25);
  overflow: hidden;
}

@media screen and (max-width: 700px) {
  .layout {
    width: 100%;
    height: 100vh;
    box-shadow: none;
    transform: none;
    left: 0;
    top: 0;
  }
}
</style>
